import React from "react";

const DotsHomeM = () => (
  <svg width="326" height="573" viewBox="0 0 326 573" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{mixBlendMode: "difference"}}>
<path className="st0" d="M91,9.1c0.5-2.2,2.6-3.5,4.8-3.1l0,0c2.2,0.5,3.5,2.6,3.1,4.8c-0.5,2.2-2.6,3.5-4.8,3.1l0,0
  C91.9,13.4,90.5,11.3,91,9.1z" fill="#FFFFFF" />
<path className="st0" d="M58.6,4.4c-0.2,2.2-2.1,3.9-4.3,3.7l0,0c-2.2-0.2-3.9-2.1-3.7-4.3c0.2-2.2,2.1-3.9,4.3-3.7l0,0
  C57.1,0.3,58.8,2.2,58.6,4.4z" fill="#FFFFFF" />
<path className="st0" d="M130.2,20c0.8-2.1,3.1-3.1,5.1-2.4l0,0c2.1,0.8,3.1,3.1,2.4,5.1s-3.1,3.1-5.1,2.4l0,0
  C130.5,24.4,129.4,22.1,130.2,20z" fill="#FFFFFF" />
<path className="st0" d="M17.9,3.9c0.2,2.2-1.5,4.1-3.7,4.3l0,0C12,8.3,10.1,6.7,9.9,4.5c-0.2-2.2,1.5-4.1,3.7-4.3l0,0
  C15.8,0,17.7,1.7,17.9,3.9z" fill="#FFFFFF" />
<path className="st0" d="M167.5,36.4c1.1-1.9,3.5-2.7,5.4-1.6l0,0c1.9,1.1,2.7,3.5,1.6,5.4c-1.1,1.9-3.5,2.7-5.4,1.6l0,0
  C167.2,40.7,166.5,38.3,167.5,36.4z" fill="#FFFFFF" />
<path className="st0" d="M-22.5,9.3c0.5,2.2-0.9,4.3-3,4.8l0,0c-2.2,0.5-4.3-0.9-4.8-3c-0.5-2.2,0.9-4.3,3-4.8l0,0
  C-25.1,5.8-23,7.1-22.5,9.3z" fill="#FFFFFF" />
<path className="st0" d="M202.2,57.7c1.3-1.8,3.8-2.2,5.6-0.9l0,0c1.8,1.3,2.2,3.8,0.9,5.6c-1.3,1.8-3.8,2.2-5.6,0.9l0,0
  C201.3,62,200.9,59.5,202.2,57.7z" fill="#FFFFFF" />
<path className="st0" d="M-61.6,20.5c0.8,2.1-0.2,4.4-2.3,5.2l0,0c-2.1,0.8-4.4-0.2-5.2-2.3c-0.8-2.1,0.2-4.4,2.3-5.2l0,0
  C-64.7,17.4-62.4,18.5-61.6,20.5z" fill="#FFFFFF" />
<path className="st0" d="M233.6,83.6c1.5-1.6,4.1-1.6,5.7-0.1l0,0c1.6,1.5,1.6,4.1,0.1,5.7s-4.1,1.6-5.7,0.1l0,0
  C232.1,87.7,232.1,85.2,233.6,83.6z" fill="#FFFFFF" />
<path className="st0" d="M-98.7,37.3c1.1,1.9,0.4,4.4-1.5,5.4l0,0c-1.9,1.1-4.4,0.4-5.4-1.5c-1.1-1.9-0.4-4.4,1.5-5.4l0,0
  C-102.2,34.7-99.8,35.4-98.7,37.3z" fill="#FFFFFF" />
<path className="st0" d="M261.1,113.7c1.8-1.3,4.3-1,5.6,0.7l0,0c1.3,1.8,1,4.3-0.7,5.6c-1.8,1.3-4.3,1-5.6-0.7l0,0
  C259,117.5,259.3,115,261.1,113.7z" fill="#FFFFFF" />
<path className="st0" d="M-133,59.3c1.3,1.8,1,4.3-0.7,5.6l0,0c-1.8,1.3-4.3,1-5.6-0.7c-1.3-1.8-1-4.3,0.7-5.6l0,0
  C-136.9,57.2-134.4,57.5-133,59.3z" fill="#FFFFFF" />
<path className="st0" d="M284,147.3c1.9-1.1,4.4-0.4,5.4,1.5l0,0c1.1,1.9,0.4,4.4-1.5,5.4c-1.9,1.1-4.4,0.4-5.4-1.5l0,0
  C281.4,150.8,282.1,148.4,284,147.3z" fill="#FFFFFF" />
<path className="st0" d="M-163.8,85.9c1.6,1.5,1.6,4.1,0.1,5.7l0,0c-1.5,1.6-4.1,1.6-5.7,0.1c-1.6-1.5-1.6-4.1-0.1-5.7l0,0
  C-167.9,84.4-165.4,84.4-163.8,85.9z" fill="#FFFFFF" />
<path className="st0" d="M301.9,183.9c2.1-0.8,4.4,0.2,5.2,2.3l0,0c0.8,2.1-0.2,4.4-2.3,5.2c-2.1,0.8-4.4-0.2-5.2-2.3l0,0
  C298.8,187,299.8,184.7,301.9,183.9z" fill="#FFFFFF" />
<path className="st0" d="M-190.6,116.6c1.8,1.3,2.2,3.8,0.9,5.6l0,0c-1.3,1.8-3.8,2.2-5.6,0.9c-1.8-1.3-2.2-3.8-0.9-5.6l0,0
  C-194.9,115.7-192.4,115.3-190.6,116.6z" fill="#FFFFFF" />
<path className="st0" d="M314.2,222.7c2.2-0.5,4.3,0.9,4.8,3l0,0l0,0c0.5,2.2-0.9,4.3-3,4.8s-4.3-0.9-4.8-3l0,0l0,0
  C310.7,225.3,312,223.2,314.2,222.7z" fill="#FFFFFF" />
<path className="st0" d="M-212.9,150.7c1.9,1.1,2.7,3.5,1.6,5.4l0,0c-1.1,1.9-3.5,2.7-5.4,1.6c-1.9-1-2.7-3.5-1.6-5.4l0,0
  C-217.2,150.4-214.8,149.6-212.9,150.7z" fill="#FFFFFF" />
<path className="st0" d="M320.8,262.9c2.2-0.2,4.1,1.5,4.3,3.7l0,0c0.2,2.2-1.5,4.1-3.7,4.3c-2.2,0.2-4.1-1.5-4.3-3.7l0,0
  C316.9,265,318.6,263.1,320.8,262.9z" fill="#FFFFFF" />
<path className="st0" d="M-230.2,187.5c2.1,0.8,3.1,3.1,2.4,5.1l0,0c-0.8,2.1-3.1,3.1-5.1,2.4c-2.1-0.8-3.1-3.1-2.4-5.1l0,0
  C-234.6,187.8-232.3,186.8-230.2,187.5z" fill="#FFFFFF" />
<path className="st0" d="M321.4,303.6c2.2,0.2,3.9,2.1,3.7,4.3l0,0c-0.2,2.2-2.1,3.9-4.3,3.7c-2.2-0.2-3.9-2.1-3.7-4.3v0
  C317.3,305.1,319.2,303.5,321.4,303.6z" fill="#FFFFFF" />
<path className="st0" d="M-242.2,226.4c2.2,0.5,3.5,2.6,3.1,4.8l0,0c-0.5,2.2-2.6,3.5-4.8,3.1c-2.2-0.5-3.5-2.6-3.1-4.8l0,0
  C-246.5,227.3-244.4,226-242.2,226.4z" fill="#FFFFFF" />
<path className="st0" d="M316.2,344c2.2,0.5,3.5,2.6,3.1,4.8l0,0c-0.5,2.2-2.6,3.5-4.8,3.1c-2.2-0.5-3.5-2.6-3.1-4.8l0,0
  C311.9,344.9,314,343.5,316.2,344z" fill="#FFFFFF" />
<path className="st0" d="M-248.6,266.7c2.2,0.2,3.9,2.1,3.7,4.3l0,0c-0.2,2.2-2.1,3.9-4.3,3.7c-2.2-0.2-3.9-2.1-3.7-4.3v0
  C-252.7,268.2-250.8,266.5-248.6,266.7z" fill="#FFFFFF" />
<path className="st0" d="M305.2,383.2c2.1,0.8,3.1,3.1,2.4,5.1l0,0c-0.8,2.1-3.1,3.1-5.1,2.4c-2.1-0.8-3.1-3.1-2.4-5.1l0,0
  C300.9,383.5,303.2,382.5,305.2,383.2z" fill="#FFFFFF" />
<path className="st0" d="M-249.1,307.4c2.2-0.2,4.1,1.5,4.3,3.7l0,0c0.2,2.2-1.5,4.1-3.7,4.3c-2.2,0.2-4.1-1.5-4.3-3.7l0,0
  C-253,309.5-251.3,307.5-249.1,307.4z" fill="#FFFFFF" />
<path className="st0" d="M288.9,420.5c1.9,1,2.7,3.5,1.6,5.4l0,0c-1.1,1.9-3.5,2.7-5.4,1.6c-1.9-1.1-2.7-3.5-1.6-5.4l0,0
  C284.5,420.2,287,419.5,288.9,420.5z" fill="#FFFFFF" />
<path className="st0" d="M-243.7,347.7c2.2-0.5,4.3,0.9,4.8,3l0,0c0.5,2.2-0.9,4.3-3,4.8c-2.2,0.5-4.3-0.9-4.8-3l0,0
  C-247.2,350.4-245.9,348.2-243.7,347.7z" fill="#FFFFFF" />
<path className="st0" d="M267.6,455.2c1.8,1.3,2.2,3.8,0.9,5.6l0,0c-1.3,1.8-3.8,2.2-5.6,0.9c-1.8-1.3-2.2-3.8-0.9-5.6l0,0
  C263.3,454.3,265.8,453.9,267.6,455.2z" fill="#FFFFFF" />
<path className="st0" d="M241.7,486.6c1.6,1.5,1.6,4.1,0.1,5.7l0,0c-1.5,1.6-4.1,1.6-5.7,0.1c-1.6-1.5-1.6-4.1-0.1-5.7l0,0
  C237.5,485.1,240.1,485.1,241.7,486.6z" fill="#FFFFFF" />
<path className="st0" d="M211.6,514.1c1.3,1.8,1,4.3-0.7,5.6l0,0c-1.8,1.3-4.3,1-5.6-0.7c-1.3-1.8-1-4.3,0.7-5.6l0,0
  C207.7,512,210.2,512.4,211.6,514.1z" fill="#FFFFFF" />
<path className="st0" d="M178,537c1.1,1.9,0.4,4.4-1.5,5.4l0,0c-1.9,1.1-4.4,0.4-5.4-1.5c-1.1-1.9-0.4-4.4,1.5-5.4l0,0
  C174.4,534.4,176.9,535.1,178,537z" fill="#FFFFFF" />
<path className="st0" d="M141.4,554.9c0.8,2.1-0.2,4.4-2.3,5.2l0,0c-2.1,0.8-4.4-0.2-5.2-2.3c-0.8-2.1,0.2-4.4,2.3-5.2l0,0
  C138.2,551.8,140.6,552.8,141.4,554.9z" fill="#FFFFFF" />
<path className="st0" d="M102.5,567.2c0.5,2.2-0.9,4.3-3,4.8l0,0c-2.2,0.5-4.3-0.9-4.8-3c-0.5-2.2,0.9-4.3,3-4.8l0,0
  C99.9,563.7,102.1,565.1,102.5,567.2z" fill="#FFFFFF" />
</g>
</svg>
);

export default DotsHomeM;
